import { CONNECTION_STATE_CHANGE } from 'aws-amplify/api';
import { Hub } from 'aws-amplify/utils';


Hub.listen("api", (data) => {
  const { payload } = data;
  if (payload.event === CONNECTION_STATE_CHANGE) {
    SubscriptionManager.connectionState= payload.data.connectionState;
    if (payload.data.connectionState === "Connected") {
  	  if (SubscriptionManager.priorDisconnection) SubscriptionManager.notifyReconnect();
  	  SubscriptionManager.priorDisconnection= false;
    }else if (payload.data.connectionState === "ConnectedPendingNetwork" ||
              payload.data.connectionState === "ConnectionDisrupted" ||
              payload.data.connectionState === "ConnectionDisruptedPendingNetwork" ||
              payload.data.connectionState === "Disconnected") {
  	  SubscriptionManager.priorDisconnection= true;
    }
  }
});

const SubscriptionManager = {
  subscriptionMap: new Map(),
  priorDisconnection: false,
  connectionState: null,
  init: function(){
  	this.subscriptionMap.clear();
  	this.priorDisconnection= false;
  },

  addSubscription: function(key, sub) {
    this.subscriptionMap.set(key, sub);
  },
  
  removeSubscription: function(key) {
	const obj= this.subscriptionMap.get(key);
	if (obj){
		if (obj.subscription) obj.subscription.unsubscribe();
		this.subscriptionMap.delete(key);
	}
  },
  
  getSubscription: function(key) {
    return this.subscriptionMap.get(key);
  },
  
  hasSubscription: function(key) {
    return this.subscriptionMap.has(key);
  },
  
  allSubscriptions: function(){
	  return this.subscriptionMap.values();
  },
  
  unsubscribeAll: function(){
	for (let [key, value] of this.subscriptionMap) {
		try{
		   if (value.subscription) value.subscription.unsubscribe();
		}catch(e){
		}
	}
  },
  
  notifyReconnect: function(){
	for (let [key, value] of this.subscriptionMap) {
		if (value.reconnect) value.reconnect();
	}
  },
  
};


export default SubscriptionManager;